module.exports = __webpack_public_path__ + "static/media/icon-symptoms-difficulty-breathing.dd023c85.svg";